import { render, staticRenderFns } from "./rating-statistic.vue?vue&type=template&id=4d77935e"
import script from "./rating-statistic.vue?vue&type=script&lang=js"
export * from "./rating-statistic.vue?vue&type=script&lang=js"
import style0 from "./rating-statistic.vue?vue&type=style&index=0&id=4d77935e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports